import { render } from "./header.vue?vue&type=template&id=671ae13a&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=671ae13a&scoped=true&lang=css"
import "./header.vue?vue&type=style&index=1&id=671ae13a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671ae13a"]])

export default __exports__